import React, { useEffect, useState } from "react";
import './FiresPage.scss';
import Spinner from '../../Spinner.js';
import { useFiresContext } from '../../../contexts/FiresContext.js';
import AllFires from './AllFires.js';
import Perimeters from "./Perimeters.js";
import HistoricalFires from "./HistoricalFires.js";
import { Fire  as FireIcon }from "@phosphor-icons/react";

export default function FiresPage(props) {
    const {
        fires,
        modal,
        setModal,
        getFires
    } = useFiresContext();

    const { 
        setPanel, 
        map,
        user,
        panel
    } = props;

    const [historicalFires, setHistoricalFires] = useState(null);
    
    const [stage, setStage] = useState('All Fires');

    const stageSwitch = (stage) => {
        switch (stage) {
            case 'All Fires':
                return (
                    <AllFires 
                        fires={fires}
                        setPanel={setPanel}
                        map={map}
                        user={user}
                        modal={modal}
                        setModal={setModal}
                        getFires={getFires}
                        panel={panel}
                    />
                )
            case 'Perimeters':
                return (
                    <Perimeters 
                        fires={fires}
                        setPanel={setPanel}
                        map={map}
                        user={user}
                        modal={modal}
                        setModal={setModal}
                        getFires={getFires}
                    />
                )
            case 'Historical':
                return (
                    <HistoricalFires
                        setPanel={setPanel}
                        map={map}
                        user={user}
                        historicalFires={historicalFires}
                        setHistoricalFires={setHistoricalFires}
                        modal={modal}
                        setModal={setModal}
                        getFires={getFires}
                    />
                )
        }
    }

    return (
        <div className='fires-page'>
            <div className='fires-page-title'>
                {/* <FireIcon size={24} color="#db6300" weight="fill" /> */}
                <div className='fires-page-title-text'>Fires</div>
            </div>
            <div className='fires-page-description'>Real-time monitoring system offering immediate updates on up-to-date, current, fires.</div>
            {fires ?
            <div className='fires-page-content'>
                <div 
                    className='fires-page-content-add-fire-btn'
                    onClick={() => {
                        setPanel({
                            name: 'Add Fire',
                            content: null
                        })
                    }}
                >Add Fire +</div>
                <div className='fires-page-content-tabs'>
                    {['All Fires', 'Perimeters', 'Historical'].map((t, index) => (
                        <div
                            key={index}
                            className='fires-page-content-tabs-tab'
                            style={{
                                borderBottom: t === stage ? '2px solid #0080ff' : ''
                            }}
                            onClick={() => setStage(t)}
                        >
                           {t === 'All Fires' ? `All Fires (${fires.length.toLocaleString()})`
                            :
                            t === 'Perimeters' ? `Perimeters (${fires.filter((fire) => fire.geom_check).length})`
                            :
                            t
                            }
                        </div>
                    ))}
                </div>
                {stageSwitch(stage)}
            </div>
            :
            <>
                <br></br>
                <Spinner />
            </>}
        </div>
    );
}